/* eslint-disable react/jsx-no-undef */
import React from "react";
import { useLiff } from "react-liff";

// import { useNavigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import backgroundSuccess from '../../assets/images/register/bg-success.png';
import { SearchMemberProfile } from "../../services/Member";
import { SearchCampaign } from "../../services/LuckyDraw";
import { setLuckyDraw } from "../../features/LuckyDrawSlice";
import { setMember } from "../../features/MemberSlice";
import { SearchRegister } from '../../services/Register'
import useWindowDimensions from "../../functions/getScreen";
import TransparentButton from "../../components/button/TransparentButton";


export default function LuckyDrawMenu() {
    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { width } = useWindowDimensions();
    const height = (width - 50) * 48 / 100

    const [campaign, setCampaign] = React.useState({
        condition: []
    });

    React.useEffect(() => {
        fnSetData('isWaiting', false)
        fnSetData('isBingoUpload', false)
        getSearchRegister()

    }, []);

    async function getSearchRegister() {
        try {
            const { data } = await SearchRegister(lineId)
            if (+data['resultCode'] === 20000) {
                const body = data.body || {}      
                if (body['memberId'] && body['survey']) {
                    getSearchMemberProfile()
                } else if (body['memberId'] && !body['survey']) {
                    navigate('/register-member-3')
                } else if (body['employeeId']) {
                    navigate('/shop-info')
                } else {
                    navigate('/register')
                }
            } else {
                navigate('/register')
            }
        } catch (error) {
            console.log('getSearchRegister error', error)
        }

    }

    async function getSearchMemberProfile() {
        return await SearchMemberProfile({ lineId })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    // console.log(response.data.body.id)
                    // fnSetData('memberId', response.data.body.id)
                    if (response.data.body.id) {
                        fnSetDataMember('memberId', response.data.body.id)
                        fnSetData('memberId', response.data.body.id)
                        fnSetData('firstName', response.data.body.firstName)
                        getSearchCampaign()
                    } else {
                        // ปิด ??
                    }
                } else {
                    navigate("/register");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function getSearchCampaign() {
        return await SearchCampaign({ lineId })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setCampaign(response.data.body)
                } else {
                    setCampaign([])
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setLuckyDraw(tmpObj));
    }

    function fnSetDataMember(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setMember(tmpObj));
    }



    return (
        <>
            <TopLogo />
            <div
                style={{
                    background: `url(${backgroundSuccess}) no-repeat center center fixed`,
                    minHeight: "calc(100vh - 60px)",
                    backgroundSize: "cover",
                    paddingTop: "25px",
                    paddingBottom : "25px"
                }}
            >
                   {/* <div className="px-[25px]">
                        <div className="mx-auto w-fit">
                            <div className="text-white text-center text-[24px] mt-[20px]">
                                เข้าสู่หน้า
                            </div>
                            <button onClick={() => {
                                fnSetData('bannerPicture', banner)
                                fnSetData('bgPicture', bg)
                                fnSetData('campaignId', 1)
                                fnSetData('logoPicture', logo)
                                navigate('/lucky-draw')
                                // if (item.type === 'LUCKY') {
                                //     navigate('/lucky-draw')
                                // } else {
                                //     if (item.status === 'PASS') {
                                //         navigate('/bingo-result', {
                                //             state: { isSuccess: true, isRecieve: false }
                                //         })
                                //     } else if (item.status === 'FAIL') {
                                //         navigate('/bingo-result', {
                                //             state: { isSuccess: false, isRecieve: false }
                                //         })
                                //     } else if (item.status === 'HISTORY') {
                                //         navigate('/bingo-result', {
                                //             state: { isSuccess: true, isRecieve: true }
                                //         })
                                //     } else {
                                //         if (item.status === 'WAITING') {
                                //             fnSetData('isWaiting', true)
                                //         } else if (item.status === 'REUPLOAD') {
                                //             fnSetData('reUpload', true)
                                //         }
                                //         navigate('/bingo')
                                //     }
                                // }
                            }}>
                                <img alt="Banner" style={{ borderRadius: "8px", width: `${width - 50}px` }} src={banner} />

                            </button>
                        </div>
                        
                    </div>  */}

                {Array.isArray(campaign) && campaign.length > 0 && campaign.map((item, index) => (
                    <div className="px-[25px]" key={index}>
                        <div className="mx-auto w-fit">
                            <div className="text-white text-center text-[24px] mt-[20px]">
                                เข้าสู่หน้า
                            </div>
                            <button onClick={() => {
                                fnSetData('bannerPicture', item.bannerPicture)
                                fnSetData('bgPicture', item.bgPicture)
                                fnSetData('campaignId', item.id)
                                fnSetData('logoPicture', item.logoPicture)
                                if (item.type === 'LUCKY') {
                                    navigate('/lucky-draw')
                                } else {
                                    if (item.status === 'PASS') {
                                        navigate('/bingo-result', {
                                            state: { isSuccess: true, isRecieve: false }
                                        })
                                    } else if (item.status === 'FAIL') {
                                        navigate('/bingo-result', {
                                            state: { isSuccess: false, isRecieve: false }
                                        })
                                    } else if (item.status === 'HISTORY') {
                                        navigate('/bingo-result', {
                                            state: { isSuccess: true, isRecieve: true }
                                        })
                                    } else {
                                        if (item.status === 'WAITING') {
                                            fnSetData('isWaiting', true)
                                        } else if (item.status === 'REUPLOAD') {
                                            fnSetData('reUpload', true)
                                        }
                                        navigate('/bingo')
                                    }
                                }
                            }}>
                                <img alt="Banner" style={{ borderRadius: "8px", width: `${width - 50}px` }} src={item.bannerPicture} />

                            </button>
                        </div>
                    </div>

                ))}

                {campaign.length <= 0 &&
                    <>
                        <div className="leading-[34px] text-[34px] no-event text-white text-center">
                            <p className="mb-[20px]">
                                ติดตามกิจกรรมใหม่ๆ <br></br> ของ Haier Privilege <br></br> ผ่านทาง Social media  <br></br> ของเราได้เลยครับ
                            </p>
                            <TransparentButton
                                className="w-[80%]"
                                variant="outlined"
                                onClick={() => liff.closeWindow()}
                            >
                                <p>ย้อนกลับ</p>
                            </TransparentButton>
                        </div>

                    </>
                }




            </div>
        </>
    );
}
